"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsReceivedRequest = void 0;
var IsReceivedRequest = /** @class */ (function () {
    function IsReceivedRequest() {
    }
    return IsReceivedRequest;
}());
exports.IsReceivedRequest = IsReceivedRequest;
;
//# sourceMappingURL=isreceived.request.js.map